
import { Link } from "react-router-dom";
import { BlogType } from "./type";

function BlogCards({ blog }: { blog: BlogType }) {
  const createSlug = (title: string) =>
    title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");

  const blogUrl = `/blog/${createSlug(blog.Title)}`;

  return (
    <Link
      to={blogUrl}
      state={{ blog }}
      className="
        group
        flex
        flex-col
        lg:flex-row
        overflow-hidden
        rounded-[20px]
        border
        border-[#E8E8E8]
        bg-white
        hover:shadow-md
        transition-all
        duration-300
        lg:h-[290px]
        no-underline
      "
    >
      {/* IMAGE SECTION */}
      <div className="relative lg:w-[40%] h-[240px] lg:h-full overflow-hidden flex-shrink-0">
        <img
          src={blog.BlogCardImage}
          alt={blog.Title}
          className="
            h-full
            w-full
            object-cover
            transition-transform
            duration-500
            group-hover:scale-105
          "
        />

        {blog.Category && (
          <div
            className="
              absolute
              top-4
              left-4
              rounded-full
              bg-white/95
              backdrop-blur-sm
              px-3
              py-1
              text-xs
              font-semibold
              text-[#047E35]
              shadow-sm
            "
          >
            {blog.Category}
          </div>
        )}
      </div>

      {/* CONTENT SECTION */}
      <div className="flex flex-1 flex-col justify-between p-6 lg:p-8 overflow-hidden">
        <div className="overflow-hidden">
          {/* Date Label */}
          <p className="text-sm font-medium text-gray-400">
            {blog.Date}
          </p>

          {/* Title - Green */}
          <h2
            className="
              mt-2
              mb-3
              text-2xl
              font-bold
              text-[#047E35]
              leading-tight
              transition-colors
              line-clamp-2
            "
          >
            {blog.Title}
          </h2>

          {/* Summary description */}
          <p
            className="
              text-gray-500 
              text-sm 
              leading-relaxed 
              line-clamp-3
            "
          >
            {blog.Summary}
          </p>
        </div>

        {/* FOOTER SECTION */}
        <div className="mt-4 pt-2 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-3">
            {/* Avatar Circle */}
            <div
              className="
                flex
                h-8
                w-8
                items-center
                justify-center
                rounded-full
                bg-[#E6F5EC]
                font-bold
                text-xs
                text-[#047E35]
              "
            >
              {blog.Author?.charAt(0).toUpperCase()}
            </div>

            <span className="text-sm font-semibold text-gray-800">
              {blog.Author}
            </span>
          </div>

          {/* Read More Link */}
          <span className="text-sm font-semibold text-[#047E35] group-hover:underline">
            Read More &rarr;
          </span>
        </div>
      </div>
    </Link>
  );
}

export default BlogCards;